/**
 * Reopening the last session in a browser.
 *
 * The desktop simply read the files again. A browser keeps the right to read
 * them only until the tab closes, unless the user chose "allow on every visit",
 * and asking again needs a click. So when the files cannot be read yet, the
 * user is offered a button that asks for them all at once, instead of being
 * told they "could not be found".
 */
import { restoreSession } from '../stores/session'
import { useSettingsStore } from '../stores/settings'
import { dismiss, notify } from '../stores/notifications'

export async function restoreLastSession(): Promise<void> {
  const { restore, files } = useSettingsStore().value.session
  if (!restore || !Array.isArray(files) || files.length === 0) return
  const blocked = await window.api.web.needingPermission(files)
  if (blocked.length === 0) {
    await restoreSession()
    return
  }
  const n = files.length
  const id = notify(
    n === 1 ? 'Reopen the document from last time?' : `Reopen the ${n} documents from last time?`,
    {
      key: 'reopen-session',
      timeoutMs: 0,
      actions: [
        {
          label: 'Reopen',
          run: async () => {
            dismiss(id)
            await window.api.web.requestAccess(files)
            await restoreSession()
          },
        },
        { label: 'Not Now', run: () => dismiss(id) },
      ],
    }
  )
}
